export enum AccountGroups {
	Asset = 'Asset',
	Debt = 'Debt',
	Wealth = 'Wealth',
	Cost = 'Cost',
	Revenue = 'Revenue',
	Pledge = 'Pledge',
	Other = 'Other',
}

export enum AccountTypes {
	Permanent = 'Permanent',
	Temporary = 'Temporary',
	Pledge = 'Pledge',
}

export enum AccountNatures {
	DebtorRemaining = 'DebtorRemaining',
	CreditorRemaining = 'CreditorRemaining',
	AlwaysDebtor = 'AlwaysDebtor',
	AlwaysCreditor = 'AlwaysCreditor',
	Undefined = 'Undefined',
}

export enum AccountGroupTypes {
	Expense_SaleOfficeGeneral = 'Expense_SaleOfficeGeneral',
	Expense_Operating = 'Expense_Operating',
	Expense_NonOperating = 'Expense_NonOperating',
	Expense_OtherOperating = 'Expense_OtherOperating',
	Expense_OtherNonOperating = 'Expense_OtherNonOperating',
	Expense_Financial = 'Expense_Financial',
	Expense_IncomeTaxes = 'Expense_IncomeTaxes',
	Expense_Cost = 'Expense_Cost',
	Income_Operating = 'Income_Operating',
	Income_NonOperating = 'Income_NonOperating',
	Income_OtherOperating = 'Income_OtherOperating',
	Income_OtherNonOperating = 'Income_OtherNonOperating',
}

export enum FloatingCenterGroups {
	Person = 'Person',
	Company = 'Company',
	Project = 'Project',
	Department = 'Department',
	Orders = 'Orders',
	CreditsLc = 'CreditsLc',
	SaleContracts = 'SaleContracts',
	PurchaseContracts = 'PurchaseContracts',
	Product = 'Product',
	ProductCategory = 'ProductCategory',
	Warehouse = 'Warehouse',
	CostCenter = 'CostCenter',
	Service = 'Service',
	Facilities = 'Facilities',
	Personel = 'Personel',
	Bank = 'Bank',
	Cash = 'Cash',
	Other = 'Other',
}

export enum IdentityTypes {
	Real = 'Real',
	Legal = 'Legal',
}

export enum NationalityTypes {
	Iranian = 'Iranian',
	Foreign = 'Foreign',
	International = 'International',
}

export enum FormModes {
	READONLY = 'readonly',
	EDITABLE = 'editable'
}

export enum NavigationDirections {
	NEXT = 'next',
	PREVIOUS = 'previous'
}

export enum JalaliMonths {
	Farvardin,
	Ordibehesht,
	Khurdad,
	Tir,
	Mordad,
	Shahrivar,
	Mehr,
	Aban,
	Azar,
	Dey,
	Bahman,
	Esfand
}

export enum RowStates {
	Changed = 'changed',
	Unchanged = 'unchanged',
	New = 'new',
	Deleted = 'deleted'
}

export enum DocumentClosingTypes {
	Permanent = 'Permanent',
	Temporary = 'Temporary'
}

export enum DocumentGroups {
	Normal = 'Normal',
	AdjustNature = 'AdjustNature',
	CloseTemporaryAccounts = 'CloseTemporaryAccounts',
	CurrencyExchange = 'CurrencyExchange',
	Opening_Account = 'Opening_Account',
	Opening_ProductStock = 'Opening_ProductStock',
	Opening_ReceiveCheque = 'Opening_ReceiveCheque',
	Opening_PaymentCheque = 'Opening_PaymentCheque',
	Closing = 'Closing',
	TransferCostAndBenefitRemain = 'TransferCostAndBenefitRemain',
}

export enum SystemDocumentTypes {
	Unknown = 'Unknown',
	Registered = 'Registered',
	Note = 'Note',
	Reviewed = 'Reviewed',
	Accepted = 'Accepted',
	Other = 'Other'
}

export enum SaleReportGroupType {
	Product = 'Product',
	FirstFloatingCenter = 'FirstFloatingCenter',
	Company = 'Company',
	Factor = 'Factor',
	Marketer = 'Marketer',
	FactorBunch = 'FactorBunch',
	FactorFloatingCenterSaleCrawling = 'FactorFloatingCenterSaleCrawling',
	FactorProductGroupSaleCrawling = 'FactorProductGroupSaleCrawling',
	FactorProductSaleCrawling = 'FactorProductSaleCrawling',
	ProductGroup = 'ProductGroup',
	ProductFloating = 'ProductFloating',
	Classification = 'Classification'
}

export enum ProductCountCrawlingType {
	Supplier = 'supplier',
	ProductGroup = 'productGroup',
	ProductKind = 'productKind',
	Product = 'product',
	Classification = 'classification',
	Warehouse = 'warehouse',
	WarehouseCrawling = 'warehouseCrawling'
}

export enum ChequeCrawlingGroupType {
	State = 'State',
	FirstFloatingCenter = 'FirstFloatingCenter',
	SecoundFloatingCenter = 'SecoundFloatingCenter',
	ThirdFloatingCenter = 'ThirdFloatingCenter',
	Day = 'Day',
	Week = 'Week',
	Month = 'Month',
	CreatedUser = 'CreatedUser'
}

export enum FactorTypes {
	Buy = 'Buy',
	Sale = 'Sale',
	BuyReturn = 'BuyReturn',
	SaleReturn = 'SaleReturn',
	Proforma = 'Proforma',
}

export enum ReceiptHawalaGroups {
	BUYRECEIPT = 'BuyReceipt',
	SALEHAWALA = 'SaleHawala',
	WAREHOUSETRANSFER = 'WarehouseTransfer',
	WAREHOUSETAKING = 'WarehouseTaking',
	OPENINGPRODUCTSTOCK = 'OpeningProductStock',
	RECIEPTRETURNSALE = 'SaleReturnReceipt',
	HAWALARETURNBUY = 'BuyReturnHawala',

	UsBorrowProductAccountWithOthers = 'UsBorrowProductAccountWithOthers',
	ProductSampleCenterHawala = 'ProductSampleCenterHawala',
	BorrowProductHawala = 'BorrowProductHawala',
	ProductionCenterHawala = 'ProductionCenterHawala',
	ReturnProductionReceipt = 'ReturnProductionReceipt',
	BorrowProductReceipt = 'BorrowProductReceipt',
	ProductionReceipt = 'ProductionReceipt',
	ConsumeHawala = 'ConsumeHawala',
	OtherReceipt = 'OtherReceipt',
	OtherHawala = 'OtherHawala'
}

export enum CheckoutTypes {
	/// <summary>
	/// میان دوره
	/// </summary>
	MidTerm = 'MidTerm',
	/// <summary>
	/// دائمی
	/// </summary>
	Permanent = 'Permanent'
}

export enum NorouzCalculationType {
	/// <summary>
	/// پایه اداره کار
	/// </summary>
	BaseDailyWage = 'BaseDailyWage',

	/// <summary>
	/// پایه \
	/// </summary>
	ContractDailyWage = 'ContractDailyWage'
}

export enum TaxPanelSettlementMethodTypes {
	Cashe = 'Cashe',
	Credit = 'Credit',
	Hybrid = 'Hybrid'
}

export enum TaxPanelPersonTypes {
	Genuine = 'Genuine',
	Legal = 'Legal',
	CivilPartnership = 'CivilPartnership',
	NonInranianNational = 'NonInranianNational',
}

export enum TaxPanelInvoiceSubjects {
	Orginal = 'Orginal',
	Edited = 'Edited',
	Expired = 'Expired',
	SalesReturn = 'SalesReturn'
}

export enum TaxPanelInvoiceAlgorithms {
	Sales = 'Sales',
	Currency = 'Currency',
	Jewel = 'Jewel',
	Contracting = 'Contracting',
	ServiceBill = 'ServiceBill',
	Airport = 'Airport',
	Export = 'Export',
}

export enum TaxPanelInvoiceTypes {
	First = 'First',
	Second = 'Second'
}

export enum TaxPanelInvoiceMoadianTypes {
	Unsend = 'Unsend',
	Sended = 'Sended',
	Pend = 'Pend',
	Faileded = 'Faileded',
	InProgress = 'InProgress'
}

export enum NotifyCenterUpdateStatus {
	Added = 'Added', AddOrModified = 'AddOrModified', Deleted = 'Deleted'
}